import React from 'react';
import { ExternalLink, TrendingUp } from 'lucide-react';
export function ProofStats() {
  const stats = [{
    stat: '32%',
    description: 'of agencies ranked engagement rate as the most important factor in influencer marketing',
    source: 'CreatorIQ 2024 Influencer Marketing Trends Report',
    url: 'https://www.creatoriq.com/hubfs/2024%20Influencer%20Marketing%20Trends%20Report/2024%20Influencer%20Marketing%20Trends%20Report.pdf'
  }, {
    stat: '68%',
    description: 'of marketers track engagement metrics for influencer marketing effectiveness',
    source: 'Sprout Social Influencer Marketing Metrics',
    url: 'https://sproutsocial.com/insights/influencer-marketing-metrics/'
  }];
  return <section className="py-20 bg-navy-950 border-t border-slate-800" data-id="element-438">
      <div className="max-w-7xl mx-auto px-6" data-id="element-439">
        <div className="text-center mb-12" data-id="element-440">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-mint-500/10 border border-mint-500/20 mb-4" data-id="element-441">
            <TrendingUp className="w-4 h-4 text-mint-500" data-id="element-442" />
            <span className="text-mint-500 text-sm font-bold uppercase tracking-wider" data-id="element-443">
              Industry Data
            </span>
          </div>
          <h2 className="text-3xl lg:text-4xl font-bold mb-4" data-id="element-444">
            Engagement drives creator business
          </h2>
          <p className="text-lg text-slate-300 max-w-2xl mx-auto leading-relaxed" data-id="element-445">
            Brands and buyers care about who shows up, not just how many follow.
            Pulse Markets are designed to drive repeat participation and
            sustained engagement.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8 max-w-5xl mx-auto" data-id="element-446">
          {stats.map((item, idx) => <div key={idx} className="bg-navy-900 rounded-2xl p-8 border border-slate-800 hover:border-mint-500/30 transition-colors" data-id="element-447">
              <div className="text-5xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-mint-500 to-wave-500 mb-4" data-id="element-448">
                {item.stat}
              </div>
              <p className="text-lg text-slate-300 mb-6 leading-relaxed" data-id="element-449">
                {item.description}
              </p>
              <a href={item.url} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 text-sm text-mint-500 hover:text-mint-400 transition-colors group" data-id="element-450">
                <span className="font-medium" data-id="element-451">{item.source}</span>
                <ExternalLink className="w-4 h-4 group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform" data-id="element-452" />
              </a>
            </div>)}
        </div>
      </div>
    </section>;
}